import { httpClient } from "./httpClient";

type SystemType = {
  id: number;
  name: string;
  isActive: boolean;
  showAccessDetail: boolean;
  systemCategory?: {
      id: number;
      name: string;
  };
};

type Data = {
    businessUnits: SystemType[];
};

export async function getSystemTypes(): Promise<SystemType[]> {
  try {
    const { data } = await httpClient.get<Data>(
      `/api/v1/business-units`
    );
      
      return data.businessUnits;
  } catch (error) {
    throw error;
  }
}
